import { Dispatch, FC, SetStateAction } from 'react';

import { Dropdown } from '~/common/components/Form/Dropdown';

interface ICoinStepProps {
  coin: string;
  visible: boolean;
  setCoin: Dispatch<SetStateAction<string>>;
}
export const CoinStep: FC<ICoinStepProps> = ({
  coin,
  visible = false,
  setCoin,
}) => {
  return (
    <div
      style={{
        position: 'absolute',
        transition: '200ms',
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'all' : 'none',
        width: '100%',
      }}
    >
      <Dropdown
        name="currency"
        width="100%"
        placeholder="Selecione uma criptomoeda"
        valueType="image-text"
        defaultValue={coin}
        value={coin}
        onChange={(opt) => setCoin(opt as string)}
        asyncData={{
          route: '/Moeda/BuscarMoedas',
          key: 'TextoPesquisa',
          mapper: (apiData) => ({
            value: String(apiData.moedaId),
            label: `${apiData.nome} - ${apiData.abreviacao}`,
            image: apiData.imagemUrl64,
          }),
          defaultParams: {
            PageSize: 100,
          },
        }}
      />
    </div>
  );
};
